import { usePermissionsContext } from './context';
import { useReactive } from './useReactive';

export const useIsPermissionVisible = (key: string) => {
  const ctx = usePermissionsContext();
  const isVisible = useReactive(ctx.permissions.get(key)?.visible!);
  return isVisible !== false;
};
